var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showOverlay)?_c('div',{staticClass:"pause-overlay"},[_c('div',{staticClass:"icon-holder"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.togglePlay($event)}}},[_c('icon',{attrs:{"icon":"play","size":"5x"}})],1)])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17bccc79","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/player/PauseOverlay.vue
// module id = +0uh
// module chunks = 0